var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import Component from 'vue-class-component';
import { Dependencies } from '~/core/decorator';
import { Emit, Prop } from 'vue-property-decorator';
import { SmartCollectionService } from "~/services/domain-service/smart-collection.service";
import { TemplateService } from '~/services/domain-service/template.service';
import { KeyResource } from '~/components/template-manage/letter-template/letter-template.config';
import { CommonService } from "~/utils/common.service";
var LetterBatchPrint = /** @class */ (function (_super) {
    __extends(LetterBatchPrint, _super);
    function LetterBatchPrint() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.templateSet = [];
        _this.dataSet = [];
        _this.templateContent = '';
        // 最终要打印的内容
        _this.printContent = '';
        _this.printPageHeight = 0;
        _this.model = {
            overduePeriod: '',
            templateId: '',
        };
        _this.dialog = {
            printPreview: false,
        };
        return _this;
    }
    LetterBatchPrint.prototype.refreshData = function () {
        var form = this.$refs['form'];
        form.resetFields();
        this.loadingData();
        this.printPageHeight = this.getPrintPageHeight();
    };
    LetterBatchPrint.prototype.close = function () { };
    LetterBatchPrint.prototype.loadingData = function () {
        var _this = this;
        var request = {
            ids: this.selectionList.map(function (v) { return v.id; })
        };
        this.smartCollectionService.getMailPersonal(request).subscribe(function (data) { return _this.dataSet = data || []; });
    };
    /**
     * 逾期阶段改变
     */
    LetterBatchPrint.prototype.onOverduePeriodChange = function (overduePeriod) {
        var _this = this;
        if (overduePeriod) {
            this.templateService.getTemplateByOverduePeriod({ overduePeriod: overduePeriod, templateCategory: 'LETTER' }).subscribe(function (data) { return _this.templateSet = data || []; });
        }
        else {
            this.model.overduePeriod = '';
        }
        this.onTemplateChange('');
    };
    /**
     * 模板改变
     */
    LetterBatchPrint.prototype.onTemplateChange = function (templateId) {
        var _this = this;
        var templateContent = '';
        if (templateId) {
            var template = this.templateSet.find(function (v) { return v.id === templateId; });
            templateContent = template.templateContent;
        }
        this.model.templateId = templateId;
        // 处理预览的数据
        this.templatePreview(templateContent);
        // 处理要打印的数据
        var contentStr = '';
        this.dataSet.forEach(function (val, index) {
            var batchContent = "<div style=\"width:100%;height:" + _this.printPageHeight + "px\">" + templateContent + '</div>';
            KeyResource.forEach(function (v) {
                var tempValue = v.value.substr(1);
                batchContent = batchContent.replace(new RegExp('\\' + v.value, 'g'), val[tempValue]);
            });
            contentStr += batchContent;
            _this.printContent = contentStr;
        });
    };
    /**
     * 移除联系人
     */
    LetterBatchPrint.prototype.removeContact = function (scope) {
        var index = scope.$index;
        this.dataSet.splice(index, 1);
    };
    /**
     * 预览数据处理
     */
    LetterBatchPrint.prototype.templatePreview = function (templateContent) {
        var val = templateContent;
        KeyResource.forEach(function (v) {
            val = val.replace(new RegExp('\\' + v.value, 'g'), '_____________');
        });
        this.templateContent = val;
    };
    /**
     * 一键打印
     */
    LetterBatchPrint.prototype.submit = function () {
        var _this = this;
        if (this.dataSet.length === 0) {
            this.$message.info('数据为空，不能打印');
            return;
        }
        var form = this.$refs['form'];
        form.validate(function (v) {
            if (!v)
                return;
            var nWindow = window.open('.');
            nWindow.document.write(_this.printContent);
            nWindow.print();
            nWindow.close();
        });
    };
    /**
     * 打印页高度
     */
    LetterBatchPrint.prototype.getPrintPageHeight = function () {
        var type = CommonService.getBrowserType();
        var printPageHeight = 0;
        switch (type) {
            case 'chrome':
            case 'opera':
                printPageHeight = 1025;
                break;
            case '360':
                printPageHeight = 1015;
                break;
            case 'firefox':
                printPageHeight = 1050;
                break;
            default:
                break;
        }
        return printPageHeight;
    };
    __decorate([
        Dependencies(SmartCollectionService)
    ], LetterBatchPrint.prototype, "smartCollectionService", void 0);
    __decorate([
        Dependencies(TemplateService)
    ], LetterBatchPrint.prototype, "templateService", void 0);
    __decorate([
        Prop()
    ], LetterBatchPrint.prototype, "selectionList", void 0);
    __decorate([
        Emit('close')
    ], LetterBatchPrint.prototype, "close", null);
    LetterBatchPrint = __decorate([
        Component({
            components: {}
        })
    ], LetterBatchPrint);
    return LetterBatchPrint;
}(Vue));
export default LetterBatchPrint;
